import _ from "lodash";
import { AnyPageDocument } from "hyam-prismic/types";
import routes from "root/prismic-routes";

/**
 * Route path templates per document type and language, taken from
 * prismic-routes.js, e.g. "/leistungen/:category/:uid". English templates have
 * the "/en" prefix removed because Next.js adds the locale when navigating.
 */
const routesEn: Record<string, string> = {};
const routesDe: Record<string, string> = {};

_.each(routes, (route) => {
  if (route.type === "home_page" || route.type === "page") return;

  if (route.lang !== "en") {
    routesDe[route.type] = route.path;
    return;
  }

  routesEn[route.type] = route.path.replace(/^\/en/, "");
});

type LinkResolverDoc = AnyPageDocument;

/** Link resolver for alternate languages */
export const linkResolverAltLang = (doc: LinkResolverDoc, lang: string) => {
  // (1) home_page
  if (doc.type === "home_page") return "/";

  const altLang = _.find(doc?.alternate_languages, (alt) => {
    return alt?.lang === lang;
  });

  // (2) page
  if (!altLang?.uid) return "/";
  if (doc.type === "page") return "/" + altLang.uid;

  const template = lang === "en" ? routesEn[doc.type] : routesDe[doc.type];

  // (3) page type not found
  if (!template) return "/";

  // (4) all other page types: fill in the route parameters. Routes with a
  // category (treatments) need the category uid of the alternate-language
  // document, which the document's getStaticProps adds as `category_uid`.
  if (template.includes(":category") && !altLang.category_uid) return "/";

  return template
    .replace(":category", altLang.category_uid || "")
    .replace(":uid", altLang.uid);
};
